export default __webpack_public_path__ + "static/sales_1-1a35c74e0fe8c7461e6e9a5b7106f9ff.png";